import { Datagrid, DateField, FunctionField, List, TextField } from "react-admin";

export function AuditList() {
  return (
    <List perPage={50} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <DateField source="created_at" showTime />
        <TextField source="action" />
        <TextField source="target_type" />
        <TextField source="target_id" sx={{ fontFamily: "monospace", fontSize: 11 }} />
        <FunctionField
          label="payload"
          render={(r: { payload: unknown }) => (r.payload ? JSON.stringify(r.payload) : "")}
          sx={{ fontFamily: "monospace", fontSize: 11 }}
        />
        <TextField source="ip" />
      </Datagrid>
    </List>
  );
}
